module.exports = __webpack_public_path__ + "static/media/p52_table_minButton.92d588c6.svg";